import { useInfiniteQuery } from "@tanstack/react-query";
import { getVoiceMailHistory, GetVoiceMailHistoryResponse } from "../actions/get-voice-mail-history.action";

type UseVoiceMailHistoryQueryParams = {
    limit?: number;
    enabled?: boolean;
    phoneNumber?: string;
};

export const useVoiceMailHistoryQuery = ({
    limit = 10,
    enabled = true,
    phoneNumber,
}: UseVoiceMailHistoryQueryParams = {}) => {
    return useInfiniteQuery<GetVoiceMailHistoryResponse>({
        queryKey: ["voice-mail-history", limit, phoneNumber],
        initialPageParam: 1,
        staleTime: 0,
        gcTime: 0,
        refetchOnMount: "always",
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        queryFn: ({ pageParam }) =>
            getVoiceMailHistory({
                page: pageParam as number,
                limit,
                phoneNumber
            }),
        getNextPageParam: (lastPage) => {
            const hasMore = lastPage.page < lastPage.totalPages;
            return hasMore ? lastPage.page + 1 : undefined;
        },
        enabled,
    });
};